import React, { useState } from 'react';
import Modal from 'react-modal';
import axios from 'axios';


Modal.setAppElement('#root');

const OverlayForm = ({ isOpen, onRequestClose }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [yoe, setYoe] = useState('');
    const [company, setCompany] = useState('');
    const [interests, setInterests] = useState({
      findingNewLeads: false,
      leadEnrichment: false,
      reachingOutToLeads: false,
      advisorDevelopment: false,
      other: false,
    });
    const [comments, setComments] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault()
        const response = await axios.post('https://0urp7fhu11.execute-api.us-east-2.amazonaws.com/prod/send-email', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({      
            email,
            company,
            name,
            yoe,
            interests,
            comments,
        }),
        })
        if (response.status === 200) {
          alert('Thank you for signing up! We will be in touch.')
          setEmail('')
          setCompany('')
          setYoe('');
          setName('');
          setInterests({
            findingNewLeads: false,
            leadEnrichment: false,
            reachingOutToLeads: false,
            advisorDevelopment: false,
            other: false,
          });
          setComments('');
          onRequestClose()
        } else {
          alert('There was an issue with your submission. Please try again.')
        }
      }

      const handleInterestChange = (event) => {
        const { name, checked } = event.target;
        setInterests((prevInterests) => ({
          ...prevInterests,
          [name]: checked,
        }));
      };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Sign Up Form"
      className="Modal"
      overlayClassName="Overlay"
    >
      <h2>Sign Up for Updates</h2>
      <form onSubmit={handleSubmit} className="form">
      <label htmlFor="name" className="form-label">Name:</label>
        <input
          type="name"
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          className="form-input"
        />
        <label htmlFor="email" className="form-label">Email:</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="form-input"
        />
        <label htmlFor="yoe" className="form-label">Years you have been licensed and in production:</label>
        <select
          id="yoe"
          value={yoe}
          onChange={(e) => setYoe(e.target.value)}
          className="form-input"
        >
          <option value="">Select...</option>
          <option value="0-1">0-1</option>
          <option value="1-3">1-3</option>
          <option value="3-5">3-5</option>
          <option value="5+">5+</option>
        </select>
        <label htmlFor="company" className="form-label">Firm Name:</label>
        <input
          type="company"
          id="company"
          value={company}
          onChange={(e) => setCompany(e.target.value)}
          required
          className="form-input"
        />
        <label className="form-label">What features are you interested in?</label>
        <div className="form-checkbox-group">
          <label className="form-checkbox-label">
            <input
              type="checkbox"
              name="findingNewLeads"
              checked={interests.findingNewLeads}
              onChange={handleInterestChange}
            />
            Lead Generation
          </label>
          <label className="form-checkbox-label">
            <input
              type="checkbox"
              name="leadEnrichment"
              checked={interests.leadEnrichment}
              onChange={handleInterestChange}
            />
            Enriching Leads
          </label>
          <label className="form-checkbox-label">
            <input
              type="checkbox"
              name="reachingOutToLeads"
              checked={interests.reachingOutToLeads}
              onChange={handleInterestChange}
            />
            Content generation and outreach design
          </label>
          <label className="form-checkbox-label">
            <input
              type="checkbox"
              name="advisorDevelopment"
              checked={interests.advisorDevelopment}
              onChange={handleInterestChange}
            />
            Sales training / Advisor development
          </label>
          <label className="form-checkbox-label">
            <input
              type="checkbox"
              name="other"
              checked={interests.other}
              onChange={handleInterestChange}
            />
            Other (please specify in comments)
          </label>
        </div>

        <label htmlFor="comments" className="form-label">Comments:</label>
        <textarea
          id="comments"
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          className="form-textarea"
        ></textarea>

        <button type="submit" className="form-button">Submit</button>
        <button type="button" onClick={onRequestClose} className="form-button close-button">Close</button>
      </form>
    </Modal>
  );
}

export default OverlayForm;
